module.exports = __webpack_public_path__ + "img/banner.fc4abea8.png";